const commonContainerStyles = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    flex_direction: 'column',
    width: '100%',
    justify_content: 'center',
    align_items: 'center',
    border_radius: FOUNDATIONS.radius_250,
});
// STANDARD
export const commonStandardContainerVariantStyles = (FOUNDATIONS, FONT) => ({
    ...commonContainerStyles(FOUNDATIONS, FONT),
    // the only difference between STANDARD and COMPACT is the padding
    padding: FOUNDATIONS.spacing_300,
});
// COMPACT
export const commonCompactContainerVariantStyles = (FOUNDATIONS, FONT) => ({
    ...commonContainerStyles(FOUNDATIONS, FONT),
    // the only difference between STANDARD and COMPACT is the padding
    padding: `${FOUNDATIONS.spacing_300} ${FOUNDATIONS.spacing_250}`,
});
//# sourceMappingURL=common.js.map